import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { BaseRepository } from '../../Common/Data/base.repository';

@Injectable({ providedIn: 'root' })
export class EqualizationRuleService extends BaseRepository {
    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    getByAssessor(assessorId: number): Promise<Core.EqualizationRuleModel[]> {
        return lastValueFrom(this.httpGet(`/api/EqualizationRule/Assessor/${assessorId}`));
    }

    get(equalizationRuleId: number): Promise<Core.EqualizationRuleModel> {
        return lastValueFrom(this.httpGet(`/api/EqualizationRule/${equalizationRuleId}`));
    }

    create(model: Core.EqualizationRuleCreateModel): Promise<Core.EqualizationRuleModel> {
        return lastValueFrom(this.httpPost('/api/EqualizationRule', model));
    }

    update(model: Core.EqualizationRuleUpdateModel): Promise<Core.EqualizationRuleModel> {
        return lastValueFrom(this.httpPut('/api/EqualizationRule', model));
    }

    delete(equalizationRuleId: number, rowVersion: number[]): Promise<void> {
        const options = { body: { rowVersion } };
        return lastValueFrom(this.httpDelete(`/api/EqualizationRule/${equalizationRuleId}`, options));
    }
}
